import { render, staticRenderFns } from "./StepSave.vue?vue&type=template&id=223252a6"
import script from "./StepSave.vue?vue&type=script&lang=js"
export * from "./StepSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports